// Food log rows as the app stores them. Two item shapes exist side by side, and food_items may arrive as a JSON string:
//   new: { name, portion_estimate, macros: { calories, protein_g, carbs_g, fat_g }, visual_evidence }
//   old: { name, quantity, c|calories, p|protein, cb|carbs, f|fat }   (note: old "c" is calories, "cb" is carbs)
const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

export function normalizeFoodItem(item) {
  if (!item || typeof item !== 'object') return null;
  const m = item.macros && typeof item.macros === 'object' ? item.macros : null;
  return {
    name: String(item.name || '').trim() || 'Unknown item',
    portion: item.portion_estimate || item.quantity || '',
    calories: num(m ? m.calories : (item.calories ?? item.c)),
    protein: num(m ? (m.protein_g ?? m.protein) : (item.protein ?? item.p)),
    carbs: num(m ? (m.carbs_g ?? m.carbs) : (item.carbs ?? item.cb)),
    fat: num(m ? (m.fat_g ?? m.fat) : (item.fat ?? item.f)),
    evidence: item.visual_evidence || '',
  };
}

export function parseFoodItems(log) {
  let items = log?.food_items;
  if (typeof items === 'string') {
    try { items = JSON.parse(items); } catch { items = []; }
  }
  return Array.isArray(items) ? items.map(normalizeFoodItem).filter(Boolean) : [];
}

/** A meal's totals: the items' sum when they carry numbers, else the log's own totals. */
export function logTotals(log) {
  const items = parseFoodItems(log);
  const sum = items.reduce(
    (acc, i) => ({ calories: acc.calories + i.calories, protein: acc.protein + i.protein, carbs: acc.carbs + i.carbs, fat: acc.fat + i.fat }),
    { calories: 0, protein: 0, carbs: 0, fat: 0 },
  );
  if (sum.calories > 0 || sum.protein > 0 || sum.carbs > 0 || sum.fat > 0) return sum;
  return {
    calories: num(log?.total_calories),
    protein: num(log?.total_protein_g),
    carbs: num(log?.total_carbs_g),
    fat: num(log?.total_fat_g),
  };
}

/** The day a log belongs to, as YYYY-MM-DD. */
export function logDay(log) {
  const raw = log?.log_date || log?.created_at || '';
  return String(raw).slice(0, 10) || null;
}

export function sumTotals(list) {
  return list.reduce(
    (acc, t) => ({ calories: acc.calories + t.calories, protein: acc.protein + t.protein, carbs: acc.carbs + t.carbs, fat: acc.fat + t.fat }),
    { calories: 0, protein: 0, carbs: 0, fat: 0 },
  );
}
